import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { MembershipReport } from '../../../components/reports/MembershipReport/MembershipReport';

export const MembershipReportPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle">Membership Report</h1>
      <MembershipReport />
    </Layout>
  );
};
